export const MAPBOX_GEOCODING_HOST = 'https://api.mapbox.com';

export const MAPBOX_FORWARD_GEOCODE_PATH = '/geocoding/v5/mapbox.places';

// Mapbox v5 forward geocoding query params. `country=us` scopes results to
// the continental US (match the FAA dataset); `types` limits which feature
// categories come back so autocompletion stays grounded in addresses, cities,
// POIs (airports / parks), and postcodes — not dangling countries or regions.
export const FORWARD_GEOCODE_COUNTRY = 'us';

export const FORWARD_GEOCODE_TYPES = 'address,place,poi,postcode';

export const FORWARD_GEOCODE_LIMIT = 6;

// Debounce window from the last call to `fetchResults`. 200ms is short enough
// that typing feels instant and long enough that the Mapbox API isn't hit on
// every keystroke (the drawer's autocomplete chips update in near-real time).
export const DEBOUNCE_MS = 200;

// Mapbox marks airport POIs with `properties.category` containing 'airport'.
export const AIRPORT_CATEGORY_MARKER = 'airport';

// Fallback airport detection — "( XYZ )" suffixes in `feature.text` also
// identify airports (e.g. "Austin-Bergstrom (AUS)"). 3–5 uppercase letters
// matches IATA (3) and ICAO (4) codes plus any odd 5-letter variants.
export const AIRPORT_CODE_PATTERN = /\([A-Z]{3,5}\)/;
